import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FichaDaObraService } from 'src/app/ficha-da-obra/service/ficha-da-obra.service';
import { ModalMensagemComponent } from 'src/app/shared/components/modal-mensagem/modal-mensagem.component';
import { environment } from 'src/environments/environment';
import { FiltroSelectBuscaComponent } from '../../filtro-select-busca/filtro-select-busca.component';
import { FiltroSelectOption } from '../../filtro-select/filtro-select.component';

@Component({
  selector: 'app-novo-relato',
  standalone: true,
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    ModalMensagemComponent,
    FiltroSelectBuscaComponent,
  ],
  templateUrl: './novo-relato.component.html',
  styleUrls: ['./novo-relato.component.scss'],
})
export class NovoRelatoComponent {
  BASE_IMG_URL: string = environment.BASE_IMG_URL;

  @Input() idObra: number | null = null;
  @Input() moduloId: number | null = null;
  @Output() close = new EventEmitter<void>();
  @Output() relatoCriado = new EventEmitter<any>();
  @Output() loading = new EventEmitter<boolean>();

  userId: string;

  descricaoRelato = '';
  nomeRelato = '';
  autorRelato = '';
  responsavel: any[] = [];
  selectedResponsaveis: any[] = [];

  enviarEmail = false;
  sucessoRelato: boolean = false;
  carregandoRelato = false;

  constructor(private fichaDaObraService: FichaDaObraService) {
    this.userId = localStorage.getItem('userId');
  }

  ngOnInit(): void {
    this.sucessoRelato = false;
    this.popularResponsavel();
  }

  get contatoOptions(): FiltroSelectOption[] {
    return this.responsavel.map((r) => ({ value: r.id, label: r.name }));
  }

  clear() {
    this.descricaoRelato = '';
    this.nomeRelato = '';
    this.enviarEmail = false;
    this.selectedResponsaveis = [];
  }

  criarRelato() {
    if (this.carregandoRelato || !this.idObra) {
      if (!this.idObra) console.error('idObra não informado');
      return;
    }

    this.carregandoRelato = true;
    this.loading.emit(true);

    let textTypeID = 1;
    let sendEmailContactIDs: string | null = null;

    if (this.enviarEmail && this.selectedResponsaveis.length > 0) {
      textTypeID = 2;
      sendEmailContactIDs = this.selectedResponsaveis.join(',');
    }

    const body: any = {
      textTypeID,
      title: this.nomeRelato,
      text: this.descricaoRelato,
      sendEmailContactIDs: sendEmailContactIDs,
      isEdited: false,
      reportID: 0,
    };

    this.fichaDaObraService.novoRelato(this.idObra, body, this.moduloId).subscribe({
      next: (res) => {
        this.loading.emit(false);
        this.carregandoRelato = false;
        this.relatoCriado.emit();
        this.sucessoRelato = true;
      },
      error: (err) => {
        this.loading.emit(false);
        this.carregandoRelato = false;
        console.error('Erro ao criar relato:', err);
      },
    });
  }

  continuar() {
    this.sucessoRelato = false;
    this.close.emit();
  }

  popularResponsavel(): void {
    this.fichaDaObraService.popularResponsavelObra().subscribe(
      (response) => {
        this.responsavel = (response.data || []).sort((a: any, b: any) =>
          (a.name || '').localeCompare(b.name || '', 'pt-BR')
        );
      },
      (error) => {
        console.error('Erro ao buscar responsáveis:', error);
      }
    );
  }
}
